import VideoScreen from './screen';
import { connect } from 'react-redux';
import { getListOfVideoMainTopics, getListOfVideosInTopic } from '../../../redux/actions/index';

const mapStateToProps = (state) => {
  return {
    state,
    loading: state.LoadingReducer.isLoading,
    userId: state.CommonReducer.userId,
    sessionToken: state.CommonReducer.sessionToken,
    videoTopics: state.VideoTopicsReducer.videoTopicList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListOfVideoMainTopics: (videosTopicRequestBody, openSnackbar) =>
      dispatch(getListOfVideoMainTopics(videosTopicRequestBody, openSnackbar)),
    getListOfVideosInTopic: (topicRequestBody, success, showError) =>
      dispatch(getListOfVideosInTopic(topicRequestBody, success, showError)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoScreen);
